import LuxonUtils from '@date-io/luxon'
import { DateTime } from 'luxon'

// extension of the LuxonUtils class that uses Sunday as the first day of the week instead of Monday
class CustomLuxonUtils extends LuxonUtils {
  getWeekdays() {
    return ['Su', 'M', 'Tu', 'W', 'Th', 'F', 'Sa']
  }

  getWeekArray(date) {
    const weekLength = this.getWeekdays().length

    const firstDayOfMonth = date.startOf('month')
    const lastDayOfMonth = date.endOf('month').startOf('day')

    const startOfFirstWeekOfMonth = firstDayOfMonth.minus({
      days: firstDayOfMonth.weekday % weekLength,
    })

    const weeks = []
    let currentWeek = startOfFirstWeekOfMonth

    while (currentWeek <= lastDayOfMonth) {
      const startOfWeek = currentWeek
      const newWeek = Array.from({ length: weekLength }, (_, idx) =>
        startOfWeek.plus({ days: idx }),
      )
      weeks.push(newWeek)
      currentWeek = currentWeek.plus({ days: weekLength })
    }

    return weeks
  }
}

const toLuxonDateTime = value => {
  if (DateTime.isDateTime(value)) return value
  if (value instanceof Date) return DateTime.fromJSDate(value)
  return DateTime.invalid('unsupported date value')
}

const mergeValidDateAndTime = (date, time, timezone = null) => {
  if (!date?.isValid || !time?.isValid) {
    return DateTime.invalid('invalid date or time')
  }

  const hour = time.hour
  const minute = time.minute
  if (!Number.isFinite(hour) || !Number.isFinite(minute)) {
    return DateTime.invalid('invalid time units')
  }

  let datetime = date.set({
    hour,
    minute,
    second: 0,
    millisecond: 0,
  })
  if (timezone) datetime = datetime.setZone(timezone, { keepLocalTime: true })
  return datetime
}

const buildDateTime = (date, time, timezone = null) => {
  return mergeValidDateAndTime(
    toLuxonDateTime(date),
    toLuxonDateTime(time),
    timezone,
  )
}

const buildDateTimeForNative = (date, time, timezone = null) => {
  const formattedDate = DateTime.isDateTime(date)
    ? date
    : date instanceof Date
      ? DateTime.fromJSDate(date)
      : DateTime.fromISO(date)
  const formattedTime = DateTime.isDateTime(time)
    ? time
    : time instanceof Date
      ? DateTime.fromJSDate(time)
      : DateTime.fromISO(time)
  return mergeValidDateAndTime(formattedDate, formattedTime, timezone)
}

// Checks to see if a given date is invalid or not
const isInvalidDate = date => {
  return isNaN(new Date(date).getTime())
}

export default CustomLuxonUtils
export { buildDateTime, buildDateTimeForNative, isInvalidDate }
